import React, { Component } from "react";
import "./RecommendedItineraries.css";
import { RecommendedItinerariesItem } from "./RecommendedItinerariesItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";

class RecommendedItineraries extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.RecommendedItinerariesSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.RecommendedItineraries = [
      {
        id: "1",
        title: "Jewish Israel Itinerary",
        daysTitle: "9 days tour",
        img: "RecommendedItineraries/7/JewishIsraelItinerary.jpg",
        link: "/Posts/itineraries/Jewish_Israel_Itinerary",
      },
      {
        id: "2",
        title: "Multi-Generational Israel Itinerary",
        daysTitle: "9 days tour",
        img: "RecommendedItineraries/7/MultiGenerationalIsraelItinerary.jpg",
        link: "/Posts/itineraries/Multi_Generational_Israel_Itinerary",
      },
      {
        id: "3",
        title: "ISRAEL CULINARY TOUR",
        daysTitle: "7 days tour",
        img: "RecommendedItineraries/7/ISRAELCULINARYTOUR.jpg",
        link: "/Posts/itineraries/ISRAEL_CULINARY_TOUR",
      },

      {
        id: "4",
        title: "Active Israel Itinerary",
        daysTitle: "9 days tour",
        img: "RecommendedItineraries/7/ActiveIsraelItinerary.jpg",
        link: "/Posts/itineraries/Active_Israel_Itinerary",
      },
    ];
  }

  render() {
    const RecommendedItinerariesHtml = this.RecommendedItineraries.map((o) => {
      return (
        <RecommendedItinerariesItem
          title={o.title}
          daysTitle={o.daysTitle}
          img={o.img}
          link={o.link}
          key={o.id}
          id={o.id}
        />
      );
    });
    return (
      <div className="recommended-itineraries-wrapper">
        <SimpleSlider settings={this.RecommendedItinerariesSliderSettings}>
          {RecommendedItinerariesHtml}
        </SimpleSlider>
      </div>
    );
  }
}

export default RecommendedItineraries;



// WEBPACK FOOTER //
// ./src/Components/RecommendedItineraries/RecommendedItinerariesJewish.js